import styles from "../styles/RegisterForm1.module.scss";
import React, { useState } from "react";

export default function RegisterForm1({
  email,
  handleEmailInput,
  register,
  handleUserName,
  handlePassword,
  handleConfirmPassword,
  handleFirstName,
  handleLastName,
  handleAge,
  handleGender,
}: {
  email: string;
  handleEmailInput: (event) => void;
  register: () => void;
  handleUserName: (event) => void;
  handlePassword: (event) => void;
  handleConfirmPassword: (event) => void;
  handleFirstName: (event) => void;
  handleLastName: (event) => void;
  handleAge: (event) => void;
  handleGender: (genderNumber: number) => void;
}) {
  const [maleClicked, setMaleClicked] = useState(true);

  function handleMaleButton(_) {
    setMaleClicked(true);
    handleGender(0);
  }

  function handleFemaleButton(_) {
    setMaleClicked(false);
    handleGender(1);
  }

  return (
    <div className={styles.form_container}>
      <div className={styles.horizontal_container}>
        <div>
          <p>First Name</p>
          <input onChange={handleFirstName} />
        </div>
        <div>
          <p>Last Name</p>
          <input onChange={handleLastName} />
        </div>
      </div>
      <div className={styles.horizontal_container}>
        <div>
          <p>Age</p>
          <input onChange={handleAge} />
        </div>
        <div>
          <p>Gender</p>
          <div className={styles.gender_content}>
            <button
              className={`${styles.left} ${
                maleClicked && styles.change_background
              }`}
              onClick={handleMaleButton}
            >
              male
            </button>
            <button
              className={`${styles.right} ${
                !maleClicked && styles.change_background
              }`}
              onClick={handleFemaleButton}
            >
              female
            </button>
          </div>
        </div>
      </div>
      <div className={styles.text}>Username</div>
      <input
        className={styles.username_input_dialog}
        onChange={handleUserName}
      />
      <div className={styles.text}>Password</div>
      <input
        className={styles.password_input_dialog}
        onChange={handlePassword}
      />
      <div className={styles.text}>Confirm Password</div>
      <input
        className={styles.password_input_dialog}
        onChange={handleConfirmPassword}
      />
      <div className={styles.text}>Email</div>
      <input
        className={styles.email_input_dialog}
        onChange={handleEmailInput}
        value={email}
      />
      <button className={styles.yellow_button} onClick={register}>
        Register
      </button>
      <span className={styles.smaller_dark_blue_text}>
        Already have an account?
      </span>
      <span className={styles.smaller_yellow_text}>
        &nbsp;
        <a href="login">LOG IN</a>
      </span>
    </div>
  );
}
